module.exports = __webpack_public_path__ + "img/menuboard_mc_cafe_large.28b6f682.webp";